let i = 0;

/**
 * Preload textures to GPU that are not visible from the start..
 * three.js renderer by default will not upload textures from non-visible entities.
 */
AFRAME.registerComponent('gpu-preloader', {
  dependencies: ['materials'],

  play: function () {
    setTimeout(() => {
      this.preloadFromSelector('#mainLogo');
      this.preloadFromSelector('#prevArrow');
      this.preloadFromSelector('#stepback');
      this.preloadFromSelector('.difficultyBackground');
      this.preloadFromSelector('.genreIcon');
      this.preloadFromSelector('.merkababloom');
      this.preloadFromSelector('.searchResultBackground');
      this.preloadMaterialsComponentTextures();
      this.preloadKeyboard();
      this.preloadSlice();
      this.preloadEnvMap();
      this.preloadFXs();
    }, 1000);
  },

  // Standard material.map texture got from a dom selector
  preloadFromSelector: function (selector) {
    const el = document.querySelector(selector);
    this.preloadTexture(el.getObject3D('mesh').material.map);
  },

  // List of textures gathered in `materials` system
  preloadMaterialsComponentTextures: function () {
    const textures = this.el.systems.materials.textureList;
    for (var i = 0; i < textures.length; i++) {
      this.preloadTexture(textures[i]);
    }
  },

  preloadKeyboard: function () {
    const keyboard = document.getElementById('keyboard').components['super-keyboard'];
    this.preloadTexture(keyboard.kbImg.getObject3D('mesh').material.map);
    this.preloadTexture(keyboard.keyColorPlane.getObject3D('mesh').material.map);
  },

  preloadSlice: function () {
    const button = document.getElementById('searchPrevPage');
    this.preloadTexture(button.components.slice9.material.map);
  },

  preloadEnvMap: function () {
    const wall = document.querySelector('#wallContainer [wall]');
    this.preloadTexture(wall.components.material.material.uniforms.environment.value);
  },

  preloadFXs: function () {
    const cutfx = document.querySelector('#rigContainer [mixin~=blueBeatFX]');
    this.preloadTexture(cutfx.components.material.material.uniforms.src.value);

    const minefx = document.querySelector('#rigContainer [mixin~=mineFX]');
    this.preloadTexture(minefx.components.material.material.map);
  },

  preloadTexture: function (texture) {
    if (!texture || !texture.image) {
      console.warn('[gpu-preloader] Error preloading texture', texture);
      return;
    }
    if (!texture.image.complete) {
      console.warn('[gpu-preloader] Error preloading, image not loaded', texture);
      return;
    }
    this.el.renderer.setTexture2D(texture, i++ % 8);
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['gpu-preloader',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
